import styled from 'styled-components';

export const CardCamp = styled.div`
    margin-bottom: 24px;
    
    .card {
        box-shadow: 0px 5px 30px #0000001A;
        border-radius: 20px;
        border: none;
        height:100%;
        &:hover{
            .card-donate-btn{
                display: flex;
                transition: all 0.5s;
                border-radius: 19px;
            }
        }
    }
`;
export const CardImageBody = styled.div`
    position: relative;
    .card-img {
        width: 100%;
         border-radius: 20px 20px 0 0;
         max-height: 180px;
         object-fit: cover;
    }
    
`;
export const ImageBadge = styled.div`
    position: absolute;
    top: auto;
    bottom: 10px;
    left: 0;
    right: 0;
    max-width: 167px;
    margin: 0 auto;
    background: #FFD495;
    border-radius: 17px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 2px;
`;
export const TopRatedImage = styled.span`
    display: flex;
    align-items: center;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 17px;
    padding: 5px;
`;
export const TopRatedText = styled.span`
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #333333;
`;
export const CardTextBody = styled.div`
    .card-body { 
        padding: 20px 20px 24px;

        .card-title {
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 28px;
            color: #33A7AE;
            margin-bottom: 10px;
            min-height: inherit;
            cursor: pointer;
            overflow: hidden;
           display: -webkit-box;
            -webkit-line-clamp: 2;
             line-clamp: 2;
           -webkit-box-orient: vertical;
        }
        p.card-text {
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            color: #555555;
            margin-bottom: 11px;
        }
    }
`;
export const CardRating = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
`;
export const CardBadge = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;

    .badge {
        background: #01606F !important;
        border-radius: 17px;
        padding: 5px 8px;
        font-family: "Jost", sans-serif;
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
    }
       button.view-more-btn {
            background: #F7931E !important;
            border: none !important;
            border-radius: 10px !important;
            box-shadow: 3px 5px 20px #00000033 !important;
            font-family: "Jost", sans-serif !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            line-height: 26px !important;
            padding: 7px 21px !important;
            color: #333333 !important;
            text-decoration: none;
            margin-top: 16px;
       &:hover{
           background: #FFD495 !important;
           color: #333333 !important;   
       }     
} 
`;
export const CardImageButton = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: none;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.9);
        transition: all 0.5s;
`;
export const SeeMoreResultButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 7px;

    .see-more-btn{
        padding: 13px 40px;
    }
`;